import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import { getMidiNumber, VALIDNOTES } from "../../helpers/pianoHelpers";
import {
  setNoteMidiNum,
  setCustomVocalTone,
  setShowRange,
} from "../../store/actions";
import { useSnackbar } from "notistack";
import { element } from "prop-types";
import { useState } from "react";
import React from "react";

const PopupTones = (props) => {
  const notesMidiNum = props.notesMidiNum;
  const { enqueueSnackbar } = useSnackbar();
  const OCTAVES = [2, 3, 4, 5, 6];
  const NOTES = [
    "A",
    "B♭",
    "B",
    "C",
    "C♯",
    "D",
    "E♭",
    "E",
    "F",
    "F♯",
    "G",
    "G♯",
  ];
  const [editMode, setEditMode] = useState(false);

  const selectedNotes = {};

  const visualKeyboard = document.getElementsByClassName(
    "ReactPiano__Keyboard"
  );

  function generateTunesOverlay(tones) {
    resetTunesOverlay();
    // Lowest tone
    let lowestTone = getPositionOfNote(tones.lowestTone);

    // Highest tone
    let highestTone = getPositionOfNote(tones.highestTone);
    //full bar
    let bar = document.createElement("div");
    bar.classList = "react-tone-overlay react-piano-bar";
    bar.style.left = lowestTone.left + "px";
    bar.style.width = highestTone.left - lowestTone.left + 30 + "px";
    visualKeyboard[0].appendChild(bar);

    // Bridge
    let bridgeStart = getPositionOfNote(tones.bridgeStart);
    let bridgeEnd = getPositionOfNote(tones.bridgeEnd);
    let bridgetElement = document.createElement("div");
    bridgetElement.classList = "react-tone-overlay react-piano-bridge-tone";
    bridgetElement.style.left = bridgeStart.left + "px";
    bridgetElement.style.width =
      bridgeEnd.left -
      bridgeStart.left +
      +bridgeEnd.width.replace("px", "") +
      "px";
    bridgetElement.innerHTML = "<span>Bridge</span>";
    visualKeyboard[0].appendChild(bridgetElement);
    let key = document.querySelector(
      `[data-midi="${notesMidiNum.bridgeVoiceNote[1]}"]`
    );
    key.classList.add("border-left");
    key = document.querySelector(
      `[data-midi="${notesMidiNum.bridgeVoiceNote[0]}"]`
    );
    key.classList.add("border-right");
  }

  function resetTunesOverlay() {
    document.querySelectorAll(".react-tone-overlay").forEach((element) => {
      element.remove();
    });
    document.querySelectorAll(".border-left").forEach((element) => {
      element.classList.remove("border-left");
    });
    document.querySelectorAll(".border-right").forEach((element) => {
      element.classList.remove("border-right");
    });
  }

  function getPositionOfNote(note) {
    let position = {};
    let previous = {};
    let next = {};
    note = getMidiNumber(note, props.standardLabels);
    let element = document.querySelector(
      `.ReactPiano__Key[data-midi="${note}"]`
    );

    previous.left = element.previousSibling?.offsetLeft;
    previous.width = element.previousSibling?.offsetWidth;
    next.left = element.nextSibling?.offsetLeft;
    next.width = element.nextSibling?.offsetWidth;

    if (previous.left + 15 >= element.offsetLeft)
      position.left = previous.left + previous.width - 10;
    else position.left = element.offsetLeft;

    if (element.offsetWidth !== 40) position.width = element.offsetWidth + "px";
    else position.width = "30px";

    return position;
  }

  const submitTones = (event) => {
    event.preventDefault();
    props.setNoteMidiNum({
      lowestVoiceNote: 0,
      bridgeVoiceNote: [],
      highestVoiceNote: 0,
    });
    let data = {};
    let lowestNote = document.getElementById("lowestNote").value;
    let highestNote = document.getElementById("highestNote").value;
    let bridgeNote = document.getElementById("bridgeNote").value;
    let lowestOctave = document.getElementById("lowestOctave").value;
    let highestOctave = document.getElementById("highestOctave").value;
    let bridgeOctave = document.getElementById("bridgeOctave").value;

    let lowest = lowestNote + lowestOctave;
    let highest = highestNote + highestOctave;
    let bridge = bridgeNote + bridgeOctave;

    data.lowestTone = lowest;
    data.highestTone = highest;
    data.bridgeStart = bridge;
    let indexBridgeStart = VALIDNOTES.findIndex((x) => x === bridge);

    let indexLowest = VALIDNOTES.findIndex((x) => x === lowest);
    let indexHighest = VALIDNOTES.findIndex((x) => x === highest);

    if (indexHighest <= indexLowest) {
      return enqueueSnackbar(
        "Highest tone has to be greater than the lowest.",
        "warning"
      );
    } else if (indexLowest >= indexBridgeStart) {
      return enqueueSnackbar(
        "Lowest tone has to be greater than the bridge start.",
        "warning"
      );
    } else if (indexBridgeStart + 3 >= indexHighest) {
      return enqueueSnackbar(
        "Highest tone has to be greater than the bridge end.",
        "warning"
      );
    }
    data.bridgeEnd = VALIDNOTES[indexBridgeStart + 3];

    data.validNotes = VALIDNOTES;
    data.indexLowest = indexLowest;
    data.indexHighest = indexHighest;
    data.indexBridgeStart = indexBridgeStart;
    data.indexBridgeEnd = indexBridgeStart + 3;
    data.bridgeNotesArray = VALIDNOTES.slice(
      data.indexBridgeStart,
      data.indexBridgeEnd
    );
    if (!editMode) {
      setNotesMidiNum(data);
      generateTunesOverlay(data);
      props.toggleModal();
    } else {
      props.setCustomVocalTone([
        lowestNote,
        bridgeNote,
        highestNote,
        lowestOctave,
        bridgeOctave,
        highestOctave,
      ]);
      setEditMode(false);
      localStorage.setItem("customVocalRange", [
        lowestNote,
        bridgeNote,
        highestNote,
        lowestOctave,
        bridgeOctave,
        highestOctave,
      ]);
      enqueueSnackbar("Custom Vocal Range saved successfully!", "success");
    }
  };

  const getNote = (note) => {
    let result = "";
    if (!note[2]) result = note[0];
    else result = note[0] + note[1];
    return result;
  };

  const getOctave = (note) => {
    let result = "";
    if (!note[2]) result = note[1];
    else result = note[2];
    return result;
  };
  const setNotesMidiNum = (data) => {
    notesMidiNum.lowestVoiceNote = getMidiNumber(
      data.lowestTone,
      props.standardLabels
    );
    notesMidiNum.highestVoiceNote = getMidiNumber(
      data.highestTone,
      props.standardLabels
    );
    notesMidiNum.bridgeVoiceNote = [];
    data.bridgeNotesArray.forEach((x) => {
      notesMidiNum.bridgeVoiceNote.push(getMidiNumber(x, props.standardLabels));
    });
    props.setNoteMidiNum(notesMidiNum);
  };

  const presetVocalButtons = (
    event,
    lowestNote,
    bridgeNote,
    highestNote,
    lowestOctave,
    bridgeOctave,
    highestOctave
  ) => {
    event.preventDefault();
    document.getElementById("lowestNote").value = lowestNote;
    document.getElementById("highestNote").value = highestNote;
    document.getElementById("bridgeNote").value = bridgeNote;
    document.getElementById("lowestOctave").value = lowestOctave;
    document.getElementById("highestOctave").value = highestOctave;
    document.getElementById("bridgeOctave").value = bridgeOctave;
  };
  const activateEditMode = (event) => {
    event.preventDefault();
    setEditMode(!editMode);
    presetVocalButtons(event, ...props.customVocalTone);
  };
  const toggleVocalRange = () => {
    props.setShowRange(!props.showRange);
    props.setNoteMidiNum({
      lowestVoiceNote: 0,
      bridgeVoiceNote: [],
      highestVoiceNote: 0,
    });
    document.querySelector(".react-tone-overlay")?.classList.add("hide-range");
    document
      .querySelector(".react-piano-bridge-tone")
      ?.classList.add("hide-range");
    document.querySelector(".border-left")?.classList.remove("border-left");
    document.querySelector(".border-right")?.classList.remove("border-right");
  };
  return (
    <div>
      <Modal
        size="lg"
        show={props.show}
        onHide={() => props.toggleModal()}
        aria-labelledby="vocal-range-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title id="vocal-range-popup">
            Set Vocal Range for piano
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-6">
                <label className="form-label noselect" htmlFor="mic-switch">
                  Show Vocal Range
                </label>
              </div>
              <div className="col-6 settings-group">
                <input
                  className="settings settings-light"
                  id="mic-switch"
                  type="checkbox"
                  checked={props.showRange}
                  onChange={toggleVocalRange}
                />
                <label className="settings-btn" htmlFor="mic-switch"></label>
              </div>
            </div>
            {props.showRange && (
              <>
                <button
                  className="btn btn_primary btn-lg me-1"
                  onClick={(event) =>
                    presetVocalButtons(event, "B♭", "E", "E", 2, 4, 5)
                  }
                >
                  Tenor
                </button>
                <button
                  className="btn btn_primary btn-lg me-1"
                  onClick={(event) =>
                    presetVocalButtons(event, "E", "B♭", "B♭", 2, 3, 4)
                  }
                >
                  Bass-baritone
                </button>
                <button
                  className="btn btn_primary btn-lg me-1"
                  onClick={(event) =>
                    presetVocalButtons(event, "G", "B♭", "C", 3, 4, 6)
                  }
                >
                  Soprano
                </button>
                <button
                  className="btn btn_primary btn-lg me-1"
                  onClick={(event) =>
                    presetVocalButtons(event, "D", "A", "A", 3, 4, 5)
                  }
                >
                  Contralto
                </button>

                <div className="custom-vocal-tone-wrapper">
                  <button
                    className="btn btn_primary btn-lg me-1"
                    onClick={(event) =>
                      presetVocalButtons(event, ...props.customVocalTone)
                    }
                  >
                    Custom
                  </button>
                  <button
                    className="btn custom-vocal-range-edit"
                    onClick={(event) => activateEditMode(event)}
                  >
                    <i className="fa fa-pencil"></i>
                  </button>
                </div>

                <div className="row">
                  <div className="form-group col-6">
                    <label className="form-label" htmlFor="lowestNote">
                      Lowest Note
                    </label>
                    <select
                      id="lowestNote"
                      className="form-control form-control-lg"
                      defaultValue={
                        !selectedNotes?.lowestTone
                          ? NOTES[0]
                          : getNote(selectedNotes?.lowestTone)
                      }
                    >
                      {NOTES.map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="form-group col-6">
                    <label className="form-label" htmlFor="lowestOctave">
                      Lowest Octave
                    </label>
                    <select
                      id="lowestOctave"
                      className="form-control form-control-lg"
                      defaultValue={
                        !selectedNotes?.lowestTone
                          ? OCTAVES[0]
                          : getOctave(selectedNotes?.lowestTone)
                      }
                    >
                      {OCTAVES.map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="form-group col-6">
                    <label className="form-label" htmlFor="bridgeNote">
                      Bridge Note
                    </label>
                    <select
                      id="bridgeNote"
                      className="form-control form-control-lg"
                      defaultValue={
                        !selectedNotes?.bridgeStart
                          ? NOTES[0]
                          : getNote(selectedNotes?.bridgeStart)
                      }
                    >
                      {NOTES.map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="form-group col-6">
                    <label className="form-label" htmlFor="bridgeOctave">
                      Bridge Octave
                    </label>
                    <select
                      id="bridgeOctave"
                      className="form-control form-control-lg"
                      defaultValue={
                        !selectedNotes?.bridgeStart
                          ? OCTAVES[2]
                          : getOctave(selectedNotes?.bridgeStart)
                      }
                    >
                      {OCTAVES.map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="form-group col-6">
                    <label className="form-label" htmlFor="highestNote">
                      Highest Tone
                    </label>
                    <select
                      id="highestNote"
                      className="form-control form-control-lg"
                      defaultValue={
                        !selectedNotes?.highestTone
                          ? NOTES[0]
                          : getNote(selectedNotes?.highestTone)
                      }
                    >
                      {NOTES.map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="form-group col-6 mb-2">
                    <label className="form-label" htmlFor="highestOctave">
                      Highest Octave
                    </label>
                    <select
                      id="highestOctave"
                      className="form-control form-control-lg"
                      defaultValue={
                        !selectedNotes?.highestTone
                          ? OCTAVES[3]
                          : getOctave(selectedNotes?.highestTone)
                      }
                    >
                      {OCTAVES.map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                {!editMode ? (
                  <button
                    className="btn btn_primary btn-lg"
                    onClick={(event) => submitTones(event)}
                  >
                    Set Vocal Range
                  </button>
                ) : (
                  <button
                    className="btn btn_primary btn-lg"
                    onClick={(event) => submitTones(event)}
                  >
                    Set Custom Range
                  </button>
                )}
              </>
            )}
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    notesMidiNum: state.notesMidiNum,
    NOTES: state.notes,
    standardLabels: state.standardLabels,
    customVocalTone: state.customVocalTone,
    showRange: state.showRange,
  };
};
const mapDispatchToProps = {
  setNoteMidiNum,
  setCustomVocalTone,
  setShowRange,
};
export default connect(mapStateToProps, mapDispatchToProps)(PopupTones);
